
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/[articleId]",
      function () {
        return require("private-next-pages/newsroom/[articleId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/[articleId]"])
      });
    }
  